import { Injectable } from '@angular/core';
import { UserType } from '../constants/permission';
import { PermissionService } from '../services/permission.service'

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  name: string;
  permission?: string;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  permission?: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

const MENUITEMS = [
  {
    state: 'consultation',
    name: 'Consultation',
    type: 'sub',
    icon: 'people',
    children: [
      { state: 'waiting-room', name: 'Waiting Room', permission: 'page.waitingroom' },
      { state: 'search-patient', name: 'Search For Patient', permission: 'page.searchpatient' },
      { state: 'cash-sale', name: 'Cash Sale', permission: 'page.cashsale' }
    ]
  },
  {
    state: 'booking',
    name: 'Booking Appointment',
    type: 'sub',
    icon: 'today',
    children: [
      { state: 'manage-booking', name: 'Manage Booking', permission: 'page.managebooking' }
    ]
  },
  {
    state: 'centre',
    name: 'Centre Setting',
    type: 'sub',
    icon: 'settings',
    children: [
      { state: 'news', name: 'Information', permission: 'page.newsmemo' },
      { state: 'manage-memo', name: 'Manage Memo', permission: 'page.managenewsmemo' },
      { state: 'manage-centre', name: 'Manage Centre', permission: 'page.managecentre' },
      { state: 'manage-user', name: 'Manage Centre User', permission: 'page.managecentreuser' },
      { state: 'register-user', name: 'Register User', permission: 'page.registeruser' },
      { state: 'assign-user', name: 'Add User To Centre', permission: 'page.addusertocentre' },
      { state: 'manage-price', name: 'Manage Price', permission: 'page.manageprice' },
      { state: 'manage-vaccine', name: 'Manage Vaccine Batch', permission: 'page.managevaccinestock' },
      { state: 'manage-company-accounts', name: 'Manage Company Accounts', permission: 'page.managecompanyaccount' },
      // { state: 'manage-patient', name: 'Manage Patient Accounts', permission: 'page.managepatientuser' }
    ]
  },
  {
    state: 'report',
    name: 'Report',
    type: 'sub',
    icon: 'assessment',
    children: [
      { state: 'report-all', name: 'Report', permission: 'page.report' }
    ]
  },
  {
    state: 'payment',
    name: 'Account',
    type: 'sub',
    icon: 'payment',
    children: [
      { state: 'account-payment', name: 'Account Payments', permission: 'page.accountpayment' }
    ]
  },
  {
    state: 'master-data',
    name: 'Master Data',
    type: 'sub',
    icon: 'archive',
    children: [
      { state: 'medical-categories', name: 'Medical Condition Categories', permission: 'page.medicalconditioncategory' },
      { state: 'medical', name: 'Medical Conditions', permission: 'page.medicalcondition' },
      { state: 'presciption-categories', name: 'Presciption Categories', permission: 'page.presciptioncategory' },
      { state: 'presciption', name: 'Prescriptions', permission: 'page.prescription' },
      { state: 'labtest-categories', name: 'Lab Test Categories', permission: 'page.labtestcategory' },
      { state: 'labtest', name: 'Lab Tests', permission: 'page.labtest' },
      { state: 'regions', name: 'Regions', permission: 'page.region' },
      { state: 'countries', name: 'Countries', permission: 'page.country' },
      { state: 'diseases', name: 'Diseases', permission: 'page.disease' },
      { state: 'countries-diseases', name: 'Countries - Diseases', permission: 'page.countrydisease' },
      { state: 'suppliers', name: 'Suppliers', permission: 'page.supplier' },
      { state: 'vaccines', name: 'Vaccines', permission: 'page.vaccine' },
      { state: 'diseases-vaccines', name: 'Diseases - Vaccines', permission: 'page.diseasevaccine' },
      { state: 'medical-conditions-vaccines', name: 'Medical Conditions - Vaccines', permission: 'page.medicalconditionvaccine' },
      { state: 'product-categories', name: 'Product Categories', permission: 'page.productcategory' },
      { state: 'products', name: 'Products', permission: 'page.product' },
      { state: 'email-domains', name: 'Email Domains', permission: 'page.emaildomain' },
      { state: 'consultations', name: 'Consultations', permission: 'page.consultation' },
      { state: 'centre-management-fees', name: 'Centre Management Fees', permission: 'page.centremanagementfee'},
      { state: 'manage-memo-mytmb', name: 'Manage Memo MY TMB', permission: 'page.managenewsmemo' },
      // Feature CR06
      // { state: 'clinics', name: 'Clinics', permission: 'page.manageclinic' },
      // { state: 'clinic-type', name: 'Clinic Type', permission: 'page.clinictype' },
      // { state: 'reasons', name: 'Reasons', permission: 'page.reason' }
    ]
  }
];

@Injectable()
export class MenuItems {
  constructor(private permissionService: PermissionService) {

  }

  getAll(): Menu[] {
    return MENUITEMS;
  }

  /**
   * @param userType : UserType
   * @returns Menu that user can access
   */
  getMenu(): Menu[] {
    let userMenu: Menu[] = new Array();
    for (let i = 0; i < MENUITEMS.length; i++) {
      let item: Menu = JSON.parse(JSON.stringify(MENUITEMS[i]));
      //  if (!item.permission || item.permission.includes(userType)) {
      if (item.children) {
        for (let j = 0; j < item.children.length; j++) {
          // if this userType do not have permission then remove
          const permission: string = item.children[j].permission;
          if (permission && !this.permissionService.hasPermissionOnPage(permission)) {
            item.children.splice(j, 1);
            j--;
          }
        }
      }
      if (!item.children || (item.children && item.children.length > 0)) {
        userMenu.push(item);
      }

      // }
    }
    return userMenu;
  }

  /*  add(menu: Menu) {
      MENUITEMS.push(menu);
    }*/
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/menu-items/menu-items.ts